/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { teamInfo } from "../../TeamData/teamInfo";

const ModalContainer = styled.div`
  max-width: 700px;
  min-width: 700px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  border-top: 1px solid #eceeee;

  @media (max-width: 800px) {
    width: fit-content;
    min-width: fit-content;
    height: fit-content;
    overflow: inherit;

    border-top: none;

    padding: 48px 24px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 70vh;

  padding: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 800px) {
    height: inherit;
  }

  @media (max-width: 600px) {
    padding: 0px;
  }
`;

const DescriptionContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 50px;
  text-align: left;
`;

const marginAuto = css`
  margin: 10px auto 0 0;
`;

const marginZero = css`
  margin: 0;
`;

const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  width: 100%;
  justify-content: space-between;
  margin: 25px 0px;

  @media (max-width: 800px) {
    grid-template-columns: 160px 1fr;
  }

  @media screen and (max-width: 560px) {
    grid-template-columns: 1fr;
    align-items: flex-start;
    justify-content: start;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  width: 90%;

  @media screen and (max-width: 560px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: start;

    span {
      margin-left: 12px;

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: start;
      text-align: left;
    }
  }
`;

const TextContainer = styled.div`
  > div:first-of-type {
    margin-top: 5px;
  }
`;

const RightContainer = styled.div`
  display: flex;

  @media screen and (max-width: 560px) {
    div {
      margin-top: 24px;
      margin-left: 0;
    }
  }
`;

const aboutBerserker = (
  <span>
    BerserkerMail™ comes from decades of in the trenches direct marketing
    experience from the founders, Ben Settle and Troy Broussard. BerserkerMail
    is the perfect synergy of fast and simple direct marketing with the power
    and sophistication of marketing automation.
    <br />
    <br />
    As marketers ourselves that send millions of emails per year, this system is
    built to reduce all of the time wasting drama of email marketing and build
    in the best practices we use in our own businesses. <br />
    <br />
    Most important, we use BerserkerMail every day in our various companies and
    personal businesses, so you can know with confidence that we "eat our own
    dog food" and use the very system you do as well.
  </span>
);

const aboutTeam = (
  <span>
    We have an extremely diverse and dedicated team behind BerserkerMail. Our
    teams is located all over the world, from Australia, USA, Mexico, Argentina,
    India, The Philippines, the UK, Ireland and Brazil.
    <br />
    <br />
    Troy is a former Brazilian resident for 10+ years and his wife and family
    are also Brazilian. So when we decided to create a new dedicated team for
    BerserkerMail we naturally looked to Brazil.
    <br />
    <br />
    The team is young, very bright and extremely dedicated. They are the core of
    everything we do at BerserkerMail and without their devotion,
    professionalism and dedication we would not have this platform.
    <br />
    <br />
    You can get to know them a bit below.
  </span>
);

const ContentText = styled.div`
  margin: 10px 0px;
`;

export default function AboutBerserkerModal() {
  return (
    <ModalContainer>
      <Wrapper>
        <img
          src="../images/berserker-team.png"
          css={css`
            width: 100%;
            height: auto;
          `}
        />

        <TextContainer>
          <h1
            css={css`
              ${marginAuto}
              margin-top: 25px;
            `}
          >
            About BerserkerMail
          </h1>
          <ContentText>{aboutBerserker}</ContentText>
        </TextContainer>
        <TextContainer>
          <h1
            css={css`
              ${marginAuto}
              margin-top: 20px;
            `}
          >
            About the Team
          </h1>
          <ContentText style={{ marginBottom: "20px" }}>
            {aboutTeam}
          </ContentText>
        </TextContainer>
        {teamInfo.map((member) => (
          <BottomContainer>
            <LeftContainer>
              <img
                src={member.photo}
                css={css`
                  width: 120px;
                  border-radius: 50%;
                  margin-bottom: 10px;
                `}
              />
              <span>
                <h3 css={marginZero}>{member.name}</h3>
                <div>{member.ocupation}</div>
              </span>
            </LeftContainer>
            <RightContainer>
              <DescriptionContainer>{member.description}</DescriptionContainer>
            </RightContainer>
          </BottomContainer>
        ))}
      </Wrapper>
    </ModalContainer>
  );
}
